export function RatingScore({ rating }) {
    return rating ? Number(rating).toFixed(1) : null;
}
